export function getOptionSelected(option, value) {
  return option?.id === value?.id;
}
